var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvatar4New = function SvgAvatar4New(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "auto",
    viewBox: "0 0 63 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#avatar4New_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.267 33.711a4.082 4.082 0 0 1-4.084 4.084A4.082 4.082 0 0 1 11.1 33.71a4.082 4.082 0 0 1 4.083-4.083 4.082 4.082 0 0 1 4.084 4.083Zm-13 12.084c0-.529.258-1.047.815-1.56.562-.52 1.376-.981 2.337-1.366 1.923-.77 4.245-1.158 5.764-1.158 1.52 0 3.841.388 5.765 1.158.96.385 1.775.847 2.337 1.365.556.514.815 1.032.815 1.56v1.667H6.267v-1.666Z",
    stroke: "#53B741",
    strokeWidth: 1.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#avatar4New_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.267 9.681a4.082 4.082 0 0 1-4.084 4.083A4.082 4.082 0 0 1 11.1 9.681a4.082 4.082 0 0 1 4.083-4.083 4.082 4.082 0 0 1 4.084 4.083Zm-13 12.083c0-.528.258-1.046.815-1.56.562-.518 1.376-.98 2.337-1.365 1.923-.77 4.245-1.158 5.764-1.158 1.52 0 3.841.387 5.765 1.158.96.385 1.775.847 2.337 1.365.556.514.815 1.032.815 1.56v1.667H6.267v-1.667Z",
    stroke: "#53B741",
    strokeWidth: 1.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#avatar4New_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.519 9.681a4.082 4.082 0 0 1-4.084 4.083 4.082 4.082 0 0 1-4.083-4.083 4.082 4.082 0 0 1 4.083-4.083A4.082 4.082 0 0 1 48.52 9.68Zm-13 12.083c0-.528.258-1.046.815-1.56.562-.518 1.376-.98 2.337-1.365 1.923-.77 4.245-1.158 5.764-1.158 1.52 0 3.841.387 5.764 1.158.961.385 1.776.847 2.337 1.365.557.514.816 1.032.816 1.56v1.667H35.519v-1.667Z",
    stroke: "#53B741",
    strokeWidth: 1.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#avatar4New_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.726 38.545v-.75h-3.625v-.917h3.625v-3.625h.917v3.625h3.625v.917h-3.625v3.625h-.917v-2.875Zm-11.625-8.917a4.082 4.082 0 0 1 4.084 4.083 4.082 4.082 0 0 1-4.084 4.084 4.082 4.082 0 0 1-4.083-4.084 4.082 4.082 0 0 1 4.083-4.083Zm8.917 17.833H35.185v-1.666c0-.529.258-1.047.815-1.56.562-.52 1.376-.981 2.337-1.366 1.923-.77 4.245-1.158 5.764-1.158 1.52 0 3.842.388 5.764 1.158.961.385 1.776.847 2.337 1.365.557.514.816 1.032.816 1.56v1.667Z",
    stroke: "#53B741",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "avatar4New_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.684 24.044)",
    d: "M0 0h29v29H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "avatar4New_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.684 .014)",
    d: "M0 0h29v29H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "avatar4New_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(29.936 .014)",
    d: "M0 0h29v29H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "avatar4New_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(33.227 24.044)",
    d: "M0 0h29v29H0z"
  })))));
};
export default SvgAvatar4New;